import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import BackButton from '../lib/BackButton';
import '../../scss/RacesToWatch.scss';

//console.log(races);
export default class RacesToWatch extends Component {
  render() {
    let { races } = this.props;
   // console.log(races);
  
    return (
      <div className="RacesToWatch">
        <BackButton path="/" />
        <h1 className="RacesToWatch__header">Citywide Races</h1>
  
        <div className="RacesToWatch__body">
          <ul className="RacesToWatch__races">
            {races.map((race, i) => {
              return (
                <li key={i}>
                  <Link className="RacesToWatch__link" to={{pathname: `/races/${race.slug}`, state: {previous: '/citywide-races'} }}>
                    {race.seat}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/routes/RacesToWatch.js